import { render, staticRenderFns } from "./details_fenshen.vue?vue&type=template&id=3fb443e4&scoped=true&"
import script from "./details_fenshen.vue?vue&type=script&lang=js&"
export * from "./details_fenshen.vue?vue&type=script&lang=js&"
import style0 from "./details_fenshen.vue?vue&type=style&index=0&id=3fb443e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb443e4",
  null
  
)

export default component.exports